
    import Component from 'vue-class-component';
    import {
            MedicalCertificateListItem,
            MedicalCertificateRequirementViewModel,
            RequirementsClient
    } from "@/api-client";
    import {Prop} from "vue-property-decorator";
    import RequirementSummary from "@/features/applications/components/RequirementSummary";
    import MedicalCertificateDetailsContent
            from "@/features/medicalCertificates/components/MedicalCertificateDetailsContent.vue";

    @Component({
        components: {
                MedicalCertificateDetailsContent
        }
    })
    export default class MedicalCertificateRequirementSummary extends RequirementSummary {

        @Prop({required: true})
        requirement!: MedicalCertificateRequirementViewModel;

        chosenMedicalCertificate: MedicalCertificateListItem | null = null;

        async created() {
            if(this.requirementValue){
                this.chosenMedicalCertificate = await new RequirementsClient().chosenMedicalCertificate(this.application.id, this.requirement.id);
            }
        }
    }
